<template>
<!-- 分享申诉 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
      <el-form style="display:flex;" class="findform">
        <el-form-item label="所属城市：" style="display:flex;width:30%;">
          <el-cascader placeholder="请选择城市" style="width:90%" filterable clearable
            :options="options" v-model="chengshi" @change="handleChange"/>
        </el-form-item>
        <el-form-item label="店铺名称：" style="display:flex;width:30%">
          <el-input v-model="vipCardName" placeholder="请输入店铺名称" style="width:90%"/>
        </el-form-item>
        <el-form-item label="创客电话：" style="display:flex;width:30%">
          <el-input v-model="vipCardPhone" placeholder="请输入创客电话" style="width:90%" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" />
        </el-form-item>
      </el-form>
      <el-form style="display:flex;" class="findform">
        <el-form-item label="申诉时间：" style="display:flex;width:30%">
          <el-date-picker type="daterange" v-model="shTime" unlink-panels @change="changeTimeSh" style="width:90%"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item label="状　　态：" style="display:flex;width:30%">
          <el-select v-model="ztid" placeholder="请选择" style="width:90%" ref="mySelect">
            <el-option v-for="(item,index) in zhuangtai" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="未通过原因：" style="display:flex;width:30%">
          <el-select v-model="ssmdId" placeholder="请选择" style="width:90%" ref="mySelect" filterable>
            <el-option v-for="(item,index) in ssmdOptions" :key="index" :value="item.dDicId" :label="item.dDicName"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">分享申诉</p>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" class="invoice_tab" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60px">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="所属城市" align="center">
          <template scope="scope">{{scope.row.pname}}-{{scope.row.cname}}</template>
        </el-table-column>
        <el-table-column label="店铺名称" align="center">
          <template scope="scope">{{scope.row.shopname}}</template>
        </el-table-column>
        <el-table-column label="分享类型" align="center">
          <template scope="scope">{{scope.row.tasktypename}}</template>
        </el-table-column>
        <el-table-column label="分享内容" align="center">
          <template scope="scope">{{scope.row.taskname}}</template>
        </el-table-column>
        <el-table-column label="未通过原因" align="center">
          <template scope="scope">{{scope.row.remark}}</template>
        </el-table-column>
        <el-table-column label="申诉时间" align="center">
          <template scope="scope">{{scope.row.appealtime}}</template>
        </el-table-column>
        <el-table-column label="创客电话" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">{{scope.row.statusname}}</template>
        </el-table-column>
        <el-table-column label="操作人" align="center">
          <template scope="scope">{{scope.row.operatorname}}</template>
        </el-table-column>
        <el-table-column label="操作时间" align="center">
          <template scope="scope">{{scope.row.opertetime}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="seeOrder(scope.row, 1)" class="handle" v-show="scope.row.status != 4"> <i class="el-icon-view"></i> 查看 </span>
            <span @click="seeOrder(scope.row, 2)" class="handle" v-show="scope.row.status == 4"> <i class="el-icon-s-check"></i> 处理 </span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="initTotal" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="detailsDialog">
    <template v-slot:title>
      <span class="drawer_title">详情</span>
    </template>
    <div style="width: 90%; margin: 0 auto;">
      <div style="border-bottom: 2px solid #eee; margin-bottom: 10px;padding-top: 10px;">
        <b>任务信息</b>
        <p><span>分享内容：</span> <span>{{formDetails.taskname}}</span></p>
        <p><span>分享类型：</span> <span>{{formDetails.tasktypename}}</span></p>
        <p><span>分享文案：</span> <span>{{formDetails.remark}}</span></p>
        <p><span>截止日期：</span> <span>{{formDetails.enddate}}</span></p>
        <p><span>任务奖励：</span> <span style="color: #3BB575;">￥{{formDetails.bonus}}元</span></p>
        <p>
          <span>任务规则：</span>
          <span style="display: inline-table;">
          <ul v-for="item in formDetails.rules" :key="item">
            <li style="line-height: 25px;">{{item.sort}}.{{item.taskdesc}};</li>
          </ul>
          </span>
        </p>
      </div>
      <div>
        <b>任务进度</b>
        <ul style="width: 100%; margin: 0 auto;">
          <li class="rwjdList" v-for="(item, index) in formDetails.progress" :key="index">
            <!-- 模拟步骤条的节点，此处为圆圈 -->
            <!-- <div :class="item.status >= index+1 ? 'roundIcon roundActive':'roundIcon'"></div> -->
            <div :class="index==0 ? 'roundIcon roundActive':'roundIcon'"></div>
            <!-- 模拟步骤条连接线，动态显示  -->
            <div :class="item.status >= index+2 ? 'jdt lineActive':'jdt'" v-show="index!==formDetails.progress.length-1"></div>
            <!-- <p style="color: #999;margin-left: 20px;">{{item.createtime | filTime}}</p> -->
            <p style="color: #999;margin-left: 20px;">{{item.createtime}}</p>
            <p style="margin-left: 20px;" :class="item.isfail==1?'redClass':''">{{item.progressname}} <span v-show="item.remark">：{{item.remark}}</span></p>
            <ul class="videoandpic" v-show="item.status==1">
              <li v-for="(item, index) in formDetails.data" :key="index" @click="handleplay(item)">
                <img :src="baseOssUrl+item.videoimg"/>
                <i class="el-icon-video-play mengceng" v-show="item.datatype == 2"></i>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="drawer_foot">
        <el-button type="warning" @click="careful(6)" v-show="stateType==2">申诉驳回</el-button>
        <el-button type="primary" @click="careful(5)" v-show="stateType==2">申诉通过</el-button>
        <el-button type="primary" @click="detailsDialog = false" v-show="stateType==1">返回</el-button>
      </div>
    </div>
  </el-drawer>
  <!-- 图片查看 -->
  <el-dialog title='图片查看' :visible.sync="largeImage" width="35%" center>
    <div class="imgDialog"> <img :src="showImageUrl"/> </div>
  </el-dialog>
  <el-dialog title="视频播放" :visible.sync="videoVisible" @close="closeDialog" width="35%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
</section>
</template>
<script>
import { datadictionaryGetlist, provincegetcountys } from "../../api/newOss";
import { postappeallist, postdetail, postprogress } from "../../api/comment";
export default {
  name: 'sharingAppeals',
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          // 校准为当天0点0分0秒，仅禁用次日及以后的未来日期
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() >= today.getTime() + 24 * 3600 * 1000;
        }
      },
      show3: true,
      baseOssUrl: localStorage.BaseOssUrl,
      dataList: [], // 查询列表
      pageIndex: 1,
      initTotal: 0,

      chengshi: "", // 所属城市
      provinceId: 0,
      cityId: 0,
      tbdprovince: [],
      tbdcity: [],
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      vipCardName: "", // 店铺名称
      vipCardPhone: '', // 创客电话
      shTime: '', // 申诉时间
      ksDate2: '', // 申诉-开始时间
      jsDate2: '', // 申诉-结束时间
      ssmdId: '', // 未通过原因
      ssmdOptions: [], // 检索区域: 未通过原因

      ztid: 0, // 状态
      zhuangtai: [ // 任务状态 0=全部 1=已提交 2=审核通过 3=审核不通过 4=申诉中 5=申诉通过 6=申诉不通过 7=打款完成
        {
          Id: 0,
          Name: "全部"
        },{
          Id: 4,
          Name: "申诉中"
        },{
          Id: 5,
          Name: "申诉通过"
        },{
          Id: 6,
          Name: "申诉不通过"
        }
      ],
      shareid: '', // 用户ID
      taskid: '', // 任务ID
      stateType: 1, // 1查看 2处理
      detailsDialog: false, // 抽屉详情
      formDetails: {}, // 任务信息
      largeImage: false, // 图片查看
      showImageUrl: "",
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },

    }
  },
  filters:{
    filTime(times) {
      return times.split('T').join(' ')
    },
  },
  methods: {
    // 查询列表
    init() {
      let addParams = {
        pid: this.provinceId, // 省份ID 查全国则传0
        cid: this.cityId, // 城市ID 查全国则传0
        shopname: this.vipCardName, // 店铺名称
        phone: this.vipCardPhone, // 创客手机号
        btime: this.ksDate2, // 申诉-开始时间
        etime: this.jsDate2, // 申诉-结束时间
        status: this.ztid, // 状态
        reasonid: this.ssmdId, // 未通过原因
        pageindex: this.pageIndex, // 分页数据 当前页码
        pagesize: 10, // 分页数据 每页显示条数
      };
      postappeallist(addParams).then(data => {
        if(data){
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.list;
            this.initTotal = data.resultObj.totalcount;
          } else {
            this.dataList = [];
            this.initTotal = 0;
          }
        }else{
          this.dataList = [];
          this.initTotal = 0;
        }
      });
    },
    // 查看 & 处理
    seeOrder(row, stateType) {
      this.shareid = row.userid; // 用户ID
      this.taskid = row.taskid; // 任务ID
      this.stateType = stateType; // 1查看 2处理
      this.detailsDialog = true;
      var addParams = {
        userid: this.shareid, // 用户ID
        taskid: this.taskid, // 任务ID
      };
      postdetail(addParams).then(data => {
        this.formDetails = data.resultObj;
      })
    },
    // 5申诉通过 & 6申诉驳回
    careful(valType) {
      this.getprogress(valType);
    },
    // 更新任务状态
    getprogress(val){
      let addParams = {
        userid: this.shareid, // 用户ID
        taskid: this.taskid, // 任务ID
        status: val, // 任务状态 0=已领取 1=已提交 2=审核通过 3=审核不通过 4=申诉中 5=申诉通过 6=申诉不通过 7=打款完成
        remark: '', // 审核备注
        operatorid: localStorage.Id, // 操作人ID
      };
      postprogress(addParams).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            text:"操作成功",
            type:"success"
          })
          this.init();
          this.detailsDialog = false; // 抽屉隐藏
        } else {
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      })
    },
    // 查看大图
    handleplay(itemI) { // 媒体素材类型 1=图片 2=视频
      if(itemI.datatype ==1) {
        this.largeImage = true;
        this.showImageUrl = localStorage.BaseOssUrl + itemI.videoimg;
      }
      if(itemI.datatype ==2) {
        this.palySeevideo(localStorage.BaseOssUrl + itemI.datapath);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause();
    },
    // 申诉时间
    changeTimeSh() {
      if(this.shTime+""=="null"){
        this.shTime = ["",""]
      }
      this.ksDate2 = this.shTime[0];
      this.jsDate2 = this.shTime[1];
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 省
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname};
            provinceData.children.push(cityData);
          })
        });
        // 在省份列表的最前面添加“全国”选项
        provinceAndCityAndarea.unshift({ value: 0, label: '全国',});
        that.options = provinceAndCityAndarea;
      })
    },
    // 未通过原因
    handleStore() {
      let addParams = {
        code: 'task_audit_fail_reason',
      };
      datadictionaryGetlist(addParams).then(data => {
        if(data.resultCode == 1){
          this.ssmdOptions = data.resultObj;
          this.ssmdOptions.unshift({
            dDicId: 0,
            dDicName: "全部",
          });
        }
      })
    },
    // 重置
    fnReset() {
      this.chengshi = ""; // 所属城市
      this.provinceId = 0;
      this.cityId = 0;
      this.vipCardName = ""; // 店铺名称
      this.vipCardPhone = ''; // 创客电话
      this.shTime = ''; // 申诉
      this.ksDate2 = ''; // 申诉-开始
      this.jsDate2 = ''; // 申诉-结束
      this.ztid = 0; // 状态
      this.ssmdId = ''; // 未通过原因
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
  },
  created() {
    this.init(); // 查询列表
    this.getprovince(); // 获取省
    this.handleStore(); // 获取未通过原因
  }
}
</script>
<style scoped>
/* 详情 */
.drawer_title {
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_foot {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
.imgDialog {
  width: 100%;
  height: 360px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgDialog>img {
  width:auto; 
  height:auto; 
  max-width:100%; 
  max-height:100%;
  border-radius: 3px;
}
/* 任务进度 */
.rwjdList{
  position: relative;
}
.roundIcon {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #ccc;
  position: absolute;
  top: 3px;
  z-index: 9;
}
.roundActive {
  background-color: #3BB575;
}
.jdt {
  width: 2px;
  height: 99%;
  background-color: #ccc;
  position: absolute;
  top: 17px;
  left: 5.2px;
}
/* .lineActive {
  background-color: #3BB575;
} */
/* 视频 & 图片 集合 */
.videoandpic {
  width: 92%;
  padding-left: 20px;
  position: relative;
  display: inline-block;
}
.videoandpic>li{
  float: left;
  margin: 0 10px 5px 0;
  cursor: pointer;
}
.videoandpic>li>img {
  width: 80px;
  height: 80px;
  border-radius: 5px;
}
.mengceng {
  position: absolute;
  left: 46px;
  top: 28px;
  font-size: 30px;
  color: #666;
}
.redClass {
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// sharingAppeals.vue?191a4a59